(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["epdp-bottom-scroll-bar"] && !window.DesignMode) return;
  try {
    
  const bottomScroll = document.querySelector('.epdp-bottom-scroll');
  const heroCard = document.querySelector('.epdp-hero__card');
  const productBlock = document.querySelector('.page-content--product');
  
  bottomScroll.style.position = 'relative';

  window.addEventListener('resize', () => {
    if(window.innerWidth > 768) {
      bottomScroll.style.display = 'none';
    } else {
      bottomScroll.style.display = 'block';
    }
  });
  
  window.onscroll = function () {
    if (window.scrollY > heroCard.offsetTop + heroCard.scrollHeight - 52) {
      bottomScroll.style.position = 'fixed';
    } else {
      bottomScroll.style.position = 'relative';
    }

    if(window.scrollY > productBlock.offsetTop - window.innerHeight) {
      bottomScroll.style.position = 'relative';
    }
    
  };
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["epdp-faq"] && !window.DesignMode) return;
  try {
    
  const accordionItems = document.querySelectorAll('.epdp-faq__faq');

accordionItems.forEach((item) => {
    const header = item.querySelector('.epdp-faq__faq-header');
    header.addEventListener('click', () => {
        toggleAccordion(item);
    });
});

function toggleAccordion(accordionItem) {
    const content = accordionItem.querySelector('.epdp-faq__faq-content');
    const isActive = accordionItem.classList.contains('open');

    // Close other accordion items
    const allAccordionItems = document.querySelectorAll('.epdp-faq__faq');
    allAccordionItems.forEach((item) => {
        if (item !== accordionItem) {
            item.classList.remove('open');
            item.querySelector('.epdp-faq__faq-content').style.maxHeight = null;
        }
    });

    if (!isActive) {
        // If content is closed, open it
        accordionItem.classList.add('open');
        content.style.maxHeight = content.scrollHeight + 'px';
    } else {
        // If content is open, close it
        accordionItem.classList.remove('open');
        content.style.maxHeight = null;
    }
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["epdp-features-list"] && !window.DesignMode) return;
  try {
    
  const featuresListCards = document.querySelectorAll('.features-list__item');

  if(!featuresListCards) return;
  
  featuresListCards.forEach((card, index) => {
      const countEl = card.querySelector('.features-list__item-count');
      if (countEl) {
          countEl.textContent = `#${index + 1}`;
      }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["epdp-footer"] && !window.DesignMode) return;
  try {
    
  const footerYear = document.getElementById('footer-copyright-year');
  footerYear.textContent = new Date().getFullYear();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["epdp-header"] && !window.DesignMode) return;
  try {
      
  const timerEl = document.getElementById('epdp-header-timer');
  const minutes = 10;
  const seconds = 60;
  const currentTime = Date.parse(new Date());
  const futureTime = new Date(currentTime + minutes * seconds * 1000);
  
  function remainingTime() {
      const totalTime = Date.parse(futureTime) - Date.parse(new Date());
      let seconds = Math.floor((totalTime / 1000) % 60);
      let minutes = Math.floor((totalTime / 1000 / 60) % 60);
  
      seconds = seconds < 10 ? '0' + seconds : seconds;
      minutes = minutes < 10 ? '0' + minutes : minutes;
  
      return {
          totalTime,
          minutes,
          seconds,
      };
  }
  
  function startTimer() {
      const t = remainingTime();
      timerEl.textContent = `${t.minutes}:${t.seconds}`;
      if (t.totalTime < 1000) {
          clearInterval(timeinterval);
          timerEl.textContent = '00:00';
      }
  }
  
  const timeinterval = setInterval(startTimer, 1000);
  startTimer();
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["epdp-order-now"] && !window.DesignMode) return;
  try {
      
  const offerTimer = document.getElementById('order-offer-timer');
  const currentOfferTime = Date.parse(new Date());
  const offerEndsTime = new Date(currentOfferTime + 10 * 60 * 1000);
  
  function offerRemainingTime() {
      const totalTime = Date.parse(offerEndsTime) - Date.parse(new Date());
      let seconds = Math.floor((totalTime / 1000) % 60);
      let minutes = Math.floor((totalTime / 1000 / 60) % 60);
  
      seconds = seconds < 10 ? '0' + seconds : seconds;
      minutes = minutes < 10 ? '0' + minutes : minutes;
  
      return {
          totalTime,
          minutes,
          seconds,
      };
  }
  
  function startOfferTimer() {
      const t = offerRemainingTime();
      offerTimer.textContent = `${t.minutes}:${t.seconds}`;
      if (t.totalTime < 1000) {
          clearInterval(offerTimerInterval);
          offerTimer.textContent = '00:00';
      }
  }
  
  const offerTimerInterval = setInterval(startOfferTimer, 1000);
  startOfferTimer();
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["epdp-reviews"] && !window.DesignMode) return;
  try {
    
  const reviewsGallery = document.getElementById('reviews-gallry');
  const reviewsModal = document.getElementById('reviews-modal');
  const reviewsModalBody = reviewsModal.querySelector('.epdp-reviews__modal-body');
  const reviewsCloseBtn = document.getElementById('reviews-close-btn');
  
  reviewsGallery.addEventListener('click', (e) => {
      if (e.target.nodeName === 'IMG') {
          // showModal();
      }
  });
  
  window.addEventListener('click', (e) => {
      if (e.target === reviewsModalBody) {
          // closeModal();
      }
  });

  reviewsCloseBtn.addEventListener('click', closeModal);
  
  function showModal() {
      document.body.style.overflow = 'hidden';
      reviewsModal.classList.add('active');
  }
  function closeModal() {
      document.body.style.overflow = 'auto';
      reviewsModal.classList.remove('active');
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ps-black-friday-sale"] && !window.DesignMode) return;
  try {
    
  const headerTitle = document.querySelector('.sale__title');
  const items = document.querySelectorAll('.sale__timer-remain'); 
  
  //Setting Date
  
  const now = new Date();
  const futureDate = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 2 );
    
  //const futureDate = new Date('2023-08-31 23:59:00');
  const oneHour = 60 * 60 * 1000;
  
  //Future Time in ms
  const futureTime = futureDate.getTime();
  
  function getRemainingTime() {
      const today = new Date().getTime();
      const t = futureTime - today;
      const oneDay = 24 * 60 * 60 * 1000;
      const oneHour = 60 * 60 * 1000;
      const oneMinute = 60 * 1000;
      const oneSecond = 1000;
      let day = Math.floor(t / oneDay);
      let hour = Math.floor((t % oneDay) / oneHour);
      let minute = Math.floor((t % oneHour) / oneMinute);
      let second = Math.floor((t % oneMinute) / oneSecond);
  
      const val = [day, hour, minute, second];
      // if value is less than 10 then throw 0 before the value
      function format(item) {
          if (item < 10) {
              return `<span><p>0</p></span> <span><p>${item}</p></span>`;
          } else {
            const itemArr = item.toString().split('');
            return `<span><p>${itemArr[0]}</p></span> <span><p>${itemArr[1]}</p></span>`;
          }
      }
  
      //Displaying in the DOM
      items.forEach(function (item, index) {
          if (t > 1) {
              item.innerHTML = format(val[index]);
          } else {
              item.innerHTML = `<span><p>0</p></span> <span><p>0</p></span>`;
          }
      });
  
      if (t < 1) {
          clearInterval(countdown);
          headerTitle.textContent = 'Sorry This Promotion Has Expired.';
          headerTitle.classList.add('expired');
      }
  }
  
  //Countdown
  let countdown = setInterval(getRemainingTime, 1000);
  //invoking the function after interval
  getRemainingTime();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ps-countdown"] && !window.DesignMode) return;
  try {
    
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
const headerTitle = document.querySelector('.countdown__header-title');
const headerText = document.querySelector('.countdown__header-text');
const items = document.querySelectorAll('.countdown__timer-remain');
const copyBtn = document.getElementById('copy-code-btn');
const discountCodeContent = document.getElementById('discount-code');

//Setting Date

const now = new Date();
const futureDate = new Date(now.getFullYear(), now.getMonth() + 1, 1);
  
//const futureDate = new Date('2023-08-31 23:59:00');
const oneHour = 60 * 60 * 1000;

// Discount code
const discountCode = 'SPECIAL15';
discountCodeContent.textContent = discountCode;


  
//Future Time in ms
const futureTime = futureDate.getTime();

function getRemainingTime() {
    const today = new Date().getTime();
    const t = futureTime - today;
    const oneDay = 24 * 60 * 60 * 1000;
    const oneHour = 60 * 60 * 1000;
    const oneMinute = 60 * 1000;
    const oneSecond = 1000;
    let day = Math.floor(t / oneDay);
    let hour = Math.floor((t % oneDay) / oneHour);
    let minute = Math.floor((t % oneHour) / oneMinute);
    let second = Math.floor((t % oneMinute) / oneSecond);

    const val = [day, hour, minute, second];
    // if value is less than 10 then throw 0 before the value
    function format(item) {
        if (item < 10) {
            return `0${item}`;
        } else {
            return item;
        }
    }

    //Displaying in the DOM
    items.forEach(function (item, index) {
        if (t > 1) {
            item.innerHTML = format(val[index]);
        } else {
            item.innerHTML = '00';
        }
    });

    if (t < 1) {
        clearInterval(countdown);
        headerTitle.textContent = 'Sorry This Promotion Has Expired.';
        headerTitle.classList.add('expired');
        headerText.textContent = 'This Promotion Has Expired.';
        discountCodeContent.textContent = '';
        copyBtn.disabled = true;
    }
}

//Countdown
let countdown = setInterval(getRemainingTime, 1000);
//invoking the function after interval
getRemainingTime();

// Copy Discount Code
copyBtn.addEventListener('click', () => {
    navigator.clipboard.writeText(discountCodeContent.textContent);
    copyBtn.classList.add('copied');

    setTimeout(() => {
        copyBtn.classList.remove('copied');
    }, 2000);
});





























  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ps-faq-2"] && !window.DesignMode) return;
  try {
    
const accordionItems = document.querySelectorAll('.faq__item');

accordionItems.forEach((item) => {
    const header = item.querySelector('.faq__item-header');
    header.addEventListener('click', () => {
        toggleAccordion(item);
    });
});

function toggleAccordion(accordionItem) {
    const content = accordionItem.querySelector('.faq__item-content');
    const isActive = accordionItem.classList.contains('active');

    // Close other accordion items
    const allAccordionItems = document.querySelectorAll('.faq__item');
    allAccordionItems.forEach((item) => {
        if (item !== accordionItem) {
            item.classList.remove('active');
            item.querySelector('.faq__item-content').style.maxHeight = null;
        }
    });

    if (!isActive) {
        // If content is closed, open it
        accordionItem.classList.add('active');
        content.style.maxHeight = content.scrollHeight + 'px';
    } else {
        // If content is open, close it
        accordionItem.classList.remove('active');
        content.style.maxHeight = null;
    }
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ps-ingredients"] && !window.DesignMode) return;
  try {
    
  const accordion = document.querySelector('.ingredients__accordion');
  accordion.addEventListener('click', () => {
    const content = accordion.querySelector('.ingredients__accordion-content');
  
    accordion.classList.toggle('active');
  
    if (content.style.maxHeight) {
        content.style.maxHeight = null;
    } else {
        content.style.maxHeight = content.scrollHeight + 'px';
    }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ps-supplement-facts"] && !window.DesignMode) return;
  try {
    
const accordionItems = document.querySelectorAll('.supplement__accordion-item');

accordionItems.forEach((item) => {
    const header = item.querySelector('.supplement__accordion-btn');
    header.addEventListener('click', () => {
        toggleAccordion(item);
    });
});

function toggleAccordion(accordionItem) {
    const content = accordionItem.querySelector('.supplement__accordion-content');
    const isActive = accordionItem.classList.contains('active');

    // Close other accordion items
    const allAccordionItems = document.querySelectorAll('.supplement__accordion-item');
    allAccordionItems.forEach((item) => {
        if (item !== accordionItem) {
            item.classList.remove('active');
            item.querySelector('.supplement__accordion-content').style.maxHeight = null;
        }
    });

    if (!isActive) {
        // If content is closed, open it
        accordionItem.classList.add('active');
        content.style.maxHeight = content.scrollHeight + 'px';
    } else {
        // If content is open, close it
        accordionItem.classList.remove('active');
        content.style.maxHeight = null;
    }
}

  } catch(e) { console.error(e); }
})();
})();
